import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Subject } from 'rxjs';
import {
  filter,
  takeUntil,
} from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/modules/auth/services/auth.service';
import {
  Customer,
  CustomerService,
} from '../../../../core/modules/auth/services/customer.service';
import {
  License,
  LicenseState,
} from '../../services/licensing.interfaces';
import { LittlesisLicensingService } from '../../services/littlesis-licensing.service';

@Component({
  selector: 'app-licensing-overlay',
  templateUrl: './licensing-overlay.component.html',
  styleUrls: ['./licensing-overlay.component.scss']
})
export class LicensingOverlayComponent implements OnInit, OnDestroy {

  customer: Customer;
  maxRetries = 24;
  msBetweenRetries = 5000;
  progress = 0;

  license: License;
  licenseState: LicenseState;
  refreshing = false;
  verifyingLicense = false;
  failed = false;
  isSuperAdmin = false;
  expired;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private _customerSvc: CustomerService,
    private _authSvc: AuthService,
    private _licensingSvc: LittlesisLicensingService) {

    this.licenseState = {
      licensed: true,
      loaded: false,
      bundle: null
    };
  }

  ngOnInit(): void {
     this._authSvc.appUser$.pipe(takeUntil(this.onDestroy$))
     .subscribe((appUser) => {
        this.isSuperAdmin = appUser.role === 'admin';
      });

    this._licensingSvc.checkLicense().pipe(takeUntil(this.onDestroy$)).subscribe((licenseState) => {
      if (licenseState.loaded) {
        this.license = licenseState.license;
        this.licenseState = licenseState;
      }
    });
  }

  getQuote(): void {
    window.open(environment.urls.external.renew);
  }

  requestDataDeletion(): void {
    window.open(environment.urls.external.deletionRequest);
  }

  verifyLicense(): void {
    this.verifyingLicense = true;
     this._licensingSvc.checkLicense().subscribe(() => {
      this.verifyingLicense = false;
    });

  }

  ngOnDestroy(): void {
    this.onDestroy$.next(null);
  }

  logout(): void {
    this._authSvc.appUser$.pipe(filter(appUser => !!appUser))
      .subscribe((appUser) => this._authSvc.logout(appUser.role, true));
  }

}
